<script setup lang="ts">
import type { Component } from 'vue'
import { onNuxtReady, shallowRef, useCoreLogger, useGameSearchOverlay, watch } from '#imports'

const { isOpen, close } = useGameSearchOverlay()
const logger = useCoreLogger()

// Rendered directly once loaded, so the overlay mounts (and focuses its field) in the task of the tap that opens it.
const overlay = shallowRef<Component>()
let loading = false

// A failed load also raises a chunk error, which reloads the app.
function load() {
    if (overlay.value || loading) return

    loading = true
    import('@game/components/GameSearchOverlay.vue')
        .then((module) => {
            overlay.value = module.default
        }, (error: unknown) => {
            logger.error('Failed to load the game search overlay', error)
            close()
        })
        .finally(() => {
            loading = false
        })
}

onNuxtReady(load)

watch(isOpen, (open) => {
    if (open) load()
})
</script>

<template>
    <Transition name="game-search-overlay">
        <component :is="overlay" v-if="isOpen && overlay" />
    </Transition>
</template>
